<template>
  <v-dialog :scrollable="true" v-model="dialog" max-width="500px">
    <v-card
      class="py-2 strategio-card-container standard"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >
        Tarjetas
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text class="py-2">
        <template v-if="editedCards.length > 0">
          <v-container class="px-3 py-0">
            <template v-for="(item, index) in editedCards">
              <v-layout :key="index" align-center>
                <div class="mr-2">
                  <v-switch
                    :ripple="false"
                    class="strategio-switch-control"
                    hide-details
                    v-model="item.enabled"
                  ></v-switch>
                </div>
                <!-- <v-flex xs12 sm6>
                </v-flex> -->
                <v-flex xs12 sm12>
                  <v-text-field
                    :label="item.cardType"
                    placeholder="Etiqueta"
                    :hint="item.reference"
                    v-model="item.cardName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </template>
          </v-container>
        </template>
        <template v-else>
          <v-container>
            <v-layout wrap>
              <v-flex style="color:rgba(0,0,0,.38)" class="align-center layout">
                No data available
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-card-text>
      <!-- <v-divider></v-divider> -->
      <v-card-actions class="layout justify-center">
        <!-- <v-spacer></v-spacer> -->
        <v-btn
          small depressed rounded dark
          class="strategio-dialog-button"
          color="error"
          @click.native="dialog = false"
        >Cerrar</v-btn>
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          style="background-color:#61B965;color:white;"
          @click.native="save"
          :loading="isUpdating"
        >Grabar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {cloneDeep, partialRight, pick, map} from 'lodash'

import eventBus from '../../utils/eventBus'

import cardsStorage from '../../storage/cardsStorage'

export default {
  data () {
    return {
      dialog: false,
      editedCards: [],
      isUpdating: false
    }
  },
  created () {
    eventBus.$off('open-show-cards-dialog')
    eventBus.$on('open-show-cards-dialog', (cards) => {
      this.editedCards = cloneDeep(map(cards, partialRight(pick, ['cardType', 'cardName', 'enabled', 'reference'])))

      this.dialog = true
    })
  },
  methods: {
    save () {
      this.isUpdating = true
      cardsStorage.updateCards({
        data: {
          cards: this.editedCards
        },
        onSuccess: () => {
          this.isUpdating = false
          this.dialog = false
        },
        onError: (error) => {
          this.isUpdating = false
          console.warn('error actualizando tarjetas: ', error)
          eventBus.$emit('open-custom-snack-bar', {message: 'No se han podido actualizar las tarjetas', itsOk: false})
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/show-cards-dialog.vue